import { useState } from "react";
import { FAQS } from "@/mocks/gossip";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,360px)_1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-700 uppercase">
              <i className="ri-question-answer-line" aria-hidden="true"></i>
              FAQ
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">关于国产吃瓜，常见的问题</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              关于名场面如何被收录、内容来源与更新节奏，我们都整理在这里。如果还有疑问，欢迎到文末给我们留言。
            </p>
            <a
              href="#about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
            >
              了解更多
              <i className="ri-arrow-down-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="space-y-3">
            {FAQS.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                    isOpen ? "border-accent-300" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-base font-bold text-foreground-950">{f.q}</span>
                      <i
                        className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-xl text-primary-600 transition-transform`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}